import React from "react";

const Feature = () => {
  const TRANSPARENT_GIF =
    "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

  const featureArr = [
    {
      image: "/img/webpImg/Feature-one.webp",
      heading: "Get The Best Deals From Top Online Stores",
      subHeading:
        "TBD, The Best Deals App will help you find the best hot deals from the top online stores. ",
    },
    {
      image: "/img/webpImg/Feature-two.webp",
      heading: "Track The Price History Of Your Favourite Product ",
      subHeading:
        "Shop smarter, not faster. TBD shows you the price history of your desired product from every top online store.",
    },
    {
      image: "/img/webpImg/feature-three.webp",
      heading: "Create Your Group To Get Special Offers ",
      subHeading:
        "TBD lets you customize the groups according to your preferred categories, or from your favourite top online stores.",
    },
  ];

  return (
    <div className="items-center justify-between hidden sm:flex gap-y-10">
      <picture className="w-[45%] shrink-0">
        <source media="(max-width: 639px)" srcSet={TRANSPARENT_GIF} />
        <img
          src="/img/webpImg/tbd-offer.webp"
          alt="Feature image"
          className="w-[100%] "
        />
      </picture>

      <div className="w-[45%] flex flex-col gap-2 md:gap-3 xl:gap-5">
        <h2 className="text-[#5254DB] text-[14px] md:text-[20px] leading-[100%] tracking-[1.1px] uppercase">
          Features
        </h2>

        <p className="text-[#000] text-[25px] md:text-[34px] font-semibold leading-[90%]">
          What’s Inside?
        </p>

        {featureArr.map((data, index) => (
          <div className="relative flex items-center">
            <picture className="">
              <source
                media="(max-width: 639px)"
                srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              />
              <img
                src={data.image}
                alt="Feature image"
                className="absolute w-[60px] top-4 md:w-[78px]"
              />
            </picture>
            <div className="bg-[#FAFAFA] py-[20px] md:py-[28px] px-[35px] md:px-[40px] rounded-[8px] flex flex-col gap-1.5 md:gap-2 ml-[10%] xl:ml-[8%]">
              <h3 className="text-[15px] md:text-[18px] font-semibold leading-[110%]">
                {data.heading}
              </h3>
              <p className="text-[12px] md:text-[14px] leading-[110%] ">
                {data.subHeading}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Feature;
